import {HoverMenu, HoverMenuItem} from "components/chalky-layout/hover-menu"
import {shapeComponent, ShapeComponent} from "set-state-compare/build/shape-component"
import {StyleSheet, View} from "react-native"
import Button from "components/chalky-layout/button"
import DeleteModal from "components/school-classes/delete-modal"
import EditSchoolClassRoleModal from "routes/user/dashboard/edit-school-class-role-modal"
import Icon from "@kaspernj/api-maker/build/utils/icon"
import memo from "set-state-compare/build/memo"
import Modal from "components/modal"
import PropTypes from "prop-types"
import propTypesExact from "prop-types-exact"
import React from "react"
import Routes from "shared/routes"
import {SchoolClass} from "models"
import SchoolClassesInviteForm from "components/school-class-roles/invite-form"
import SchoolClassRolesModal from "routes/user/dashboard/school-class-roles-modal"
import useI18n from "i18n-on-steroids/src/use-i18n.mjs"

const styles = StyleSheet.create({
  columnText: {
    color: "#2c2c96"
  }
})

export default memo(shapeComponent(class ComponentsSchoolClassesOptionsButton extends ShapeComponent {
  static propTypes = propTypesExact({
    schoolClass: PropTypes.instanceOf(SchoolClass).isRequired
  })

  setup() {
    const {t} = useI18n({namespace: "js.components.school_classes.options_button"})

    this.setInstance({t})
    this.useStates({
      showAddTeacherModal: false,
      showDeleteClassModal: false,
      showNewRoleModal: false,
      showSchoolClassRolesModal: false
    })
  }

  render() {
    const {schoolClass} = this.p

    return (
      <>
        {this.s.showAddTeacherModal &&
          <EditSchoolClassRoleModal onRequestClose={this.tt.onRequestCloseAddTeacherModal} schoolClass={schoolClass} />
        }
        {this.s.showDeleteClassModal &&
          <DeleteModal onRequestClose={this.tt.onRequestCloseDeleteModal} schoolClass={schoolClass} />
        }
        {this.s.showNewRoleModal &&
          <Modal className="send-invitation-modal" onRequestClose={this.tt.onRequestCloseNewRoleModal}>
            <SchoolClassesInviteForm onInviteSent={this.tt.onInviteSent} schoolClass={schoolClass} />
          </Modal>
        }
        {this.s.showSchoolClassRolesModal &&
          <SchoolClassRolesModal onRequestClose={this.tt.onSchoolClassRolesModalRequestClose} schoolClass={schoolClass} />
        }
        <HoverMenu content={this.tt.actionsHoverMenuContent}>
          <View style={this.iconViewStyle ||= {paddingHorizontal: 8}}>
            <Icon
              dataSet={this.cache("iconDataSet", {schoolClassId: schoolClass.id()}, [schoolClass?.id()])}
              name="ellipsis-vertical"
              size={20}
              style={styles.columnText}
              testID="school-classes--options-button"
            />
          </View>
        </HoverMenu>
      </>
    )
  }

  actionsHoverMenuContent = () => {
    const {schoolClass} = this.p
    const {t} = this.tt

    return <>
      <HoverMenuItem
        label={t(".go_to_woof_space")}
        testID="go-to-woof-space-option"
        to={Routes.userSchoolClassClassSpacePath(schoolClass.id())}
      />
      {schoolClass.can("edit") &&
        <HoverMenuItem
          label={t(".edit_class")}
          testID="edit-school-class-option"
          to={Routes.editUserSchoolClassPath(schoolClass.id())}
        />
      }
      {schoolClass.can("softDelete") &&
        <HoverMenuItem
          label={t(".delete_class")}
          onPress={this.tt.onDeleteSchoolClassPressed}
          testID="delete-school-class-option"
        />
      }
      <HoverMenuItem
        label={t(".add_user")}
        onPress={this.tt.onAddTeacherPress}
        testID="add-user-option"
      />
      <HoverMenuItem
        label={t(".edit_users")}
        onPress={this.tt.onShowSchoolClassRolesModal}
        testID= "edit-users-option"
      />
      <View style={this.buttonContainerViewStyle ||= {marginTop: 10}}>
        <Button
          primary
          small
          testID="view-analysis-button"
          title={t(".view_analysis")}
          to={Routes.userUnicornPath({school_classes: [schoolClass.id()]})}
        />
      </View>
    </>
  }

  onAddTeacherPress = () => this.setState({showAddTeacherModal: true})
  onDeleteSchoolClassPressed = () => this.setState({showDeleteClassModal: true})
  onInviteSent = () => this.setState({showNewRoleModal: false})
  onRequestCloseAddTeacherModal = () => this.setState({showAddTeacherModal: false})
  onRequestCloseDeleteModal = () => this.setState({showDeleteClassModal: false})
  onRequestCloseNewRoleModal = () => this.setState({showNewRoleModal: false})
  onShowSchoolClassRolesModal = () => this.setState({showSchoolClassRolesModal: true})
  onSchoolClassRolesModalRequestClose = () => this.setState({showSchoolClassRolesModal: false})
}))
